export default "__VITE_ASSET__K9uz8NTe__"